import React from 'react';

import { SkapaTheme } from '@inter-ikea-kompis/themes';
import { ThemeFontStyleTypeEnum } from '@inter-ikea-kompis/enums';
import { KompisImage, KompisText } from '@inter-ikea-kompis/react-components';

import { t } from '../../translations';
import { translate } from '../../services/L10n';
import constants from '../../settings/constants';
import styles from './GoodToKnowTab.module.less';

const GoodToKnowTab = () => (
  <div slot="custom-tab-1">
    <KompisText
      theme={SkapaTheme}
      type={ThemeFontStyleTypeEnum.headingSmall}
      className={styles.goodToKnowHeading}
    >
      {translate(t.AURDAL_DRAWERS_GOOD_TO_KNOW_HEADING)}
    </KompisText>
    <KompisText theme={SkapaTheme} className={styles.goodToKnowDescription}>
      {translate(t.AURDAL_DRAWERS_GOOD_TO_KNOW_DESCRIPTION)}
    </KompisText>
    <KompisImage
      className={styles.goodToKnowImage}
      alt={translate(t.AURDAL_DRAWERS_GOOD_TO_KNOW_HEADING)}
      src={`${constants.IMAGE_ROOT}${constants.AURDAL_GOOD_TO_KNOW_DRAWERS_IMAGE}`}
    />
  </div>
);

export default GoodToKnowTab;
